import type { EstadoLetra } from './avaliacao';

/**
 * Mensagens da Trama (§23.5).
 *
 * Centralizadas como as de §7.3: são texto de aceite, e os testes comparam
 * com estas constantes, não com literais espalhados pela interface.
 */

export function msgPalavraDoDia(tamanho: number): string {
  return `A palavra de hoje tem ${tamanho} letras`;
}

/** Nome acessível de cada estado de letra (§13: nunca só cor). */
export const NOME_ESTADO: Readonly<Record<EstadoLetra, string>> = {
  certa: 'certa',
  presente: 'no lugar errado',
  ausente: 'não está na palavra',
};

/**
 * Anúncio de uma jogada para leitor de tela.
 *
 * As marcas da Trama são cor: verde, amarelo, cinza. Sem isto, quem usa
 * leitor de tela receberia as letras e nenhuma informação (§13).
 */
export function anunciarMarcas(texto: string, letras: readonly EstadoLetra[]): string {
  const partes = [...texto].map((letra, i) => {
    const estado = letras[i];
    return estado === undefined ? letra : `${letra} ${NOME_ESTADO[estado]}`;
  });
  return partes.join(', ');
}
